import React, { useEffect, useState } from "react";
import { Modal, Table, Avatar, Tag } from "antd";
import { UserOutlined } from "@ant-design/icons";
import { formatDateByLocale } from "../../../utils/dateFormat";
import { gql, useLazyQuery } from "@apollo/client";

const GET_SUBSCRIBERS = gql`
  query GetSubscribers($coachId: String!) {
    getSubscribers(coachId: $coachId) {
      joinDate
      subscriptionCount
      user {
        _id
        name
        email
        profile_image
        lastLoginAt
      }
    }
  }
`;

export default function SubscribersModal({ open, coachId, onCancel }) {
  const [list, setList] = useState([]);
  const [getSubscribers, { data, loading: queryLoading }] =
    useLazyQuery(GET_SUBSCRIBERS);

  useEffect(() => {
    if (open && coachId) {
      getSubscribers({
        variables: {
          coachId: coachId,
        },
      });
    } else if (!open) {
      // 关闭 modal 时清空数据
      setList([]);
    }
  }, [open, coachId, getSubscribers]);

  useEffect(() => {
    if (data?.getSubscribers) {
      setList(data.getSubscribers || []);
    }
  }, [data]);

  const columns = [
    {
      title: "Subscriber Name",
      dataIndex: ["user", "name"],
      key: "subscriberName",
      render: (_, record) => (
        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <Avatar
            src={record?.user?.profile_image}
            icon={!record?.user?.profile_image ? <UserOutlined /> : null}
            style={{
              backgroundColor: !record?.user?.profile_image
                ? "#547756"
                : undefined,
            }}
          />
          <div style={{ fontWeight: 500, fontSize: "14px" }}>
            {record?.user?.name}
          </div>
        </div>
      ),
    },
    {
      title: "User Email",
      dataIndex: ["user", "email"],
      key: "subscriberEmail",
      render: (email) => email || "-",
    },
    {
      title: "Joined Date",
      dataIndex: "joinDate",
      key: "joinDate",
      render: (date) => formatDateByLocale(date),
    },
    {
      title: "Last Active",
      dataIndex: ["user", "lastLoginAt"],
      key: "lastLoginAt",
      render: (date) => formatDateByLocale(date),
    },
    {
      title: "Subscription Count",
      key: "subscriptionCount",
      render: (_, record) => (
        <Tag color="green">{record?.subscriptionCount || 0}</Tag>
      ),
    },
  ];

  return (
    <Modal
      title="Subscribers"
      open={open}
      onCancel={onCancel}
      footer={null}
      width={800}
    >
      <Table
        columns={columns}
        dataSource={list}
        rowKey={(record) => record?.user?._id || record?.joinDate}
        loading={queryLoading}
        size="small"
      />
    </Modal>
  );
}
